module.exports = {"header":{"background":"#001529"}}


//////////////////
// WEBPACK FOOTER
// ./src/style/theme/theme-grey.json
// module id = 1911
// module chunks = 1